import { TopeCreditConfig, TopeCreditDarkConfig } from './top-credit'
import { HashSpaceLightConfig, HashSpaceDarkConfig } from './hash-space'
import { BgeLightConfig, BgeDarkConfig } from './bge'
import { V8CreditDarkConfig, V8CreditLightConfig } from './8v'
import { E97CreditLightConfig, E97CreditDarkConfig } from './97'
import type { ChartingLibraryWidgetOptions } from 'charting-library'
import { _paginationConfigMobile, paginationConfig as pageConfig } from './pagination'
import { B9DarkConfig, B9LightConfig } from './b9'
import { E88DarkConfig, E88LightConfig } from './88'

export enum ProjectTheme {
  Light = 'light',
  Dark = 'dark',
}

export enum Platform {
  TopCredit = 'topcredit',
  HashSpace = 'hashspace',
  Bge = 'bge',
  '8V' = '8v',
  B9 = 'b9',
  'e97' = 'e97',
  E88 = '88',
}
export const paginationConfig = pageConfig

export const paginationConfigMobile = _paginationConfigMobile
const ConfigMap: Record<ImportMetaEnv['VITE_PLATFORM'], PlatformConfig> = {
  [Platform.TopCredit]: TopeCreditConfig,
  [Platform.HashSpace]: HashSpaceLightConfig,
  [Platform.Bge]: BgeLightConfig,
  [Platform['8V']]: V8CreditLightConfig,
  [Platform['e97']]: E97CreditLightConfig,
  [Platform.B9]: B9LightConfig,
  [Platform.E88]: E88LightConfig,
}

type ThemePlatformConfig = {
  [ProjectTheme.Light]: PlatformConfig
  [ProjectTheme.Dark]: PlatformConfig
}

const THEME_PLATFORM_CONFIG_MAP: Record<ImportMetaEnv['VITE_PLATFORM'], ThemePlatformConfig> = {
  [Platform.TopCredit]: {
    [ProjectTheme.Light]: TopeCreditConfig,
    [ProjectTheme.Dark]: TopeCreditDarkConfig,
  },
  [Platform.HashSpace]: {
    [ProjectTheme.Light]: HashSpaceLightConfig,
    [ProjectTheme.Dark]: HashSpaceDarkConfig,
  },
  [Platform.Bge]: {
    [ProjectTheme.Light]: BgeLightConfig,
    [ProjectTheme.Dark]: BgeDarkConfig,
  },
  [Platform['8V']]: {
    [ProjectTheme.Light]: V8CreditLightConfig,
    [ProjectTheme.Dark]: V8CreditDarkConfig,
  },
  [Platform['e97']]: {
    [ProjectTheme.Light]: E97CreditLightConfig,
    [ProjectTheme.Dark]: E97CreditDarkConfig,
  },
  [Platform.B9]: {
    [ProjectTheme.Light]: B9LightConfig,
    [ProjectTheme.Dark]: B9DarkConfig,
  },
  [Platform.E88]: {
    [ProjectTheme.Light]: E88LightConfig,
    [ProjectTheme.Dark]: E88DarkConfig,
  },
}

export const PlatformName = import.meta.env.VITE_PLATFORM_NAME

export const PlatformKey = import.meta.env.VITE_PLATFORM

export const isLoopFetchAssets = import.meta.env.VITE_IS_LOOP_FETCH_ASSETS === '1'

export const isCryptoExchange = import.meta.env.VITE_CRYPTO_EXCHANGE === '1'

export const PLATFORM_CONFIG = ConfigMap[import.meta.env.VITE_PLATFORM as Platform]

export const TRADING_VIEW_OVERRIDES: ChartingLibraryWidgetOptions['overrides'] = {
  'mainSeriesProperties.candleStyle.upColor': PLATFORM_CONFIG.colors.up, // 上涨蜡烛颜色
  'mainSeriesProperties.candleStyle.downColor': PLATFORM_CONFIG.colors.down, // 下跌蜡烛颜色
  'mainSeriesProperties.candleStyle.borderUpColor': PLATFORM_CONFIG.colors.up, // 上涨蜡烛边框颜色
  'mainSeriesProperties.candleStyle.borderDownColor': PLATFORM_CONFIG.colors.down, // 下跌蜡烛边框颜色
  'mainSeriesProperties.candleStyle.wickUpColor': PLATFORM_CONFIG.colors.up, // 上涨蜡烛影线颜色
  'mainSeriesProperties.candleStyle.wickDownColor': PLATFORM_CONFIG.colors.down, // 下跌蜡烛影线颜色
  // 'scalesProperties.fontSize': 8,
}

export const THEME_PLATFORM_CONFIG = THEME_PLATFORM_CONFIG_MAP[import.meta.env.VITE_PLATFORM as Platform]
